export type EntriesToObject<T = unknown> = [T, T];

export type EntriesFromObject<T = unknown> = {
  [key: string]: T;
};

export const createObjectFromEntries = (entries: EntriesToObject[]) => {
  return Object.fromEntries(entries);
};

export const createEntries = (entries: EntriesFromObject) => {
  return Object.entries(entries);
};
